import {backendFetch} from "./NfBackendFetch";
import type {GuestModel} from "../serviceWorker/workerComponents/Models/GuestModel";
import type {PaymentMethods} from "../serviceWorker/workerComponents/Models/PaymentMethods";
import type {GroupBookingResult} from "@/frontendClasses/GroupBookingResult";
import type {BookingResult} from "@/frontendClasses/BookingResult";
import type {BookingCustomer} from "@/frontendClasses/BookingCustomer";
import type {SingleReservationInGroup} from "@/frontendClasses/SingleReservationInGroup";


/**
 * Stworzenie nowej rezerwacji
 */
export function bookReservation(widgetId:number, parameters: BookingParameters):Promise<BookingResult> {
    return backendFetch(widgetId, 'book_one', 'POST','application/json',JSON.stringify(parameters)).then(response => {
        if(response.status != 200) {
            return response.text().then( error => Promise.reject(error));
        }
        return response.json()
    });
}

/**
 * Stworzenie rezerwacji grupowej
 * @param widgetId
 * @param parameters
 */
export function bookGroupReservation(widgetId: number, parameters: GroupBookingParameters): Promise<GroupBookingResult> {
    return backendFetch(widgetId, 'book_many', 'POST','application/json',JSON.stringify(parameters)).then(response => {
        if(response.status != 200) {
            return response.text().then( error => Promise.reject(error));
        }
        return response.json()
    });

}

export interface GroupBookingParameters {
    /**
     * opcjonalnie zewnętrzne id klienta całej rezerwacji grupowej, używane w specjalnych portalach które tego potrzebują
     */
    external_customer_id?: string;
    payment_method: PaymentMethods;
    parent_location?: string;
    /**
     * id wysłanej oferty pobytowej - jeśli rezerwacja pochodzi z takiej oferty
     */
    chance_id?: number;
    /**
     * Komentarz do rezerwacji grupowej opcjonalnie
     */
    com_content?: string;
    /**
     * Opcjonalnie komentarz na temat użytego vouchera do rezerwacji grupowej
     */
    com_voucher?: string;
    customer: BookingCustomer;
    reservations: SingleReservationInGroup[];
    discount_code?: string|null;
}


export interface BookingParameters {
    /**
     * id planu cenowego
     */
    config_id: number;
    /**
     * id standardu
     */
    id: number;
    /**
     * data przyjazdu
     */
    date_from: string;
    /**
     * data wyjazdu
     */
    date_to: string;
    /**
     * ilość dorosłych
     */
    adult_count: number;
    children_ages: number[];
    /**
     * Komentarz do rezerwacji
     */
    com_content?: string;
    customer: BookingCustomer;
    guests: GuestModel[];
    payment_method: PaymentMethods;
    discount_code?: string|null;
    parent_location: string;
    chance_id?: number;
    shop_items_chosen?: {
        /**
         * Ilość per id dodatku
         */
        [additionId: number]: number
    }

}

